import { Form, Modal } from "react-bootstrap";
import "./Success_Modal.css";
import Green_Check_Lottie from "../../../Animation/green_check_lottie/Green_Check_Lottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";
import { useEffect } from "react";
const Success_Modal = ({ successText, ...props }) => {
  useEffect(() => {
    if (!props?.show) return;

    const timer = setTimeout(() => {
      props?.onHide?.();
    }, 5000);

    return () => clearTimeout(timer);
  }, [props?.show, props?.onHide]);

  const app_setup = useSelector((state) => state.master.app_setup);

  return (
    <Modal className="Login_Modal Success_Modal" size="md" {...props} centered>
      <div className="absolute_div">
        <div className="logo_holder">
          <img
            // src="/assets/images/logo/new_ekansi_logo.png"
            src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
            className="logo_img"
          />
        </div>
      </div>

      <Modal.Body>
        <div className="lottie_holder_div">
          <Successfull_Lottie />
        </div>
        <p className="success_text">{successText}</p>
      </Modal.Body>
    </Modal>
  );
};

export default Success_Modal;
